import * as React from 'react'

function IconSearch(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={30}
      height={29}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.926 24.366c6.035 0 10.927-4.892 10.927-10.926S19.96 2.514 13.926 2.514C7.892 2.514 3 7.406 3 13.44s4.892 10.926 10.926 10.926zM22.59 22.104l4.382 4.382"
        stroke="#A3A3A3"
        strokeWidth={5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IconSearch
